import { Range, Record } from 'immutable';

import _ from 'lodash';
import { getRotateByDocID } from 'lib/pdfHelpers';

export const PageParamsFactory = new Record({
  idx: 0,
  height: 0,
  rotate: 0,
  embdRotate: 0,
  status: null,
});

export function getTransform(x = 0, y = 0) {
  return `translate3d(${x}px, ${y}px, 0)`;
}

export const rumb = ['top', 'right', 'bottom', 'left'];
export const dm = ['width', 'height'];
export const angles = [0, 90, 180, 270];

export function getPropName(prop, rotate) {
  const idx = rotate / 90;
  const r = rumb.indexOf(prop);
  const d = dm.indexOf(prop);
  if (r > -1) return rumb[(r + idx) % rumb.length];
  return dm[(d + idx) % dm.length];
}

export function createRange(...arg) {
  return Range(...arg).toList();
}

export function getPageParams(pageInfo, pageParams, viewPortWidth, scale) {
  /*
  When document has embed rotation pdf.js would still provide pageInfo with height and width
  that doesnt respect embed rotation, though doc will be rendered in a right manner.
  If embeded rotation is 90/270 we must substitude width and height manually.
  Later we will do additional substitution when backend/frontend rotation is applied additionally
   */
  const isEmbedRotated = (pageParams.embdRotate / 90) % 2 === 1;

  const height = Math.abs(pageInfo.view[3] - pageInfo.view[1]);
  const width = Math.abs(pageInfo.view[2] - pageInfo.view[0]);

  const pageProportions = {
    width: isEmbedRotated ? height : width,
    height: isEmbedRotated ? width : height,
  };

  const params = {
    height: (pageProportions.height * viewPortWidth) / pageProportions.width,
    width: (pageProportions.width * viewPortWidth) / pageProportions.height,
  };

  return pageParams
    .set('height', params[getPropName('height', pageParams.rotate)] * scale)
    .set('embdRotate', pageInfo.rotate);
}

export function getPolygonStyleFactory(pageWidth, pageHeight, rotation, ratio, item) {
  const { w, h, y, x } = item.boundingPoly;
  const getFloat = (s) => parseFloat(s) * ratio;
  const left = getFloat(x);
  const width = getFloat(w);
  const height = getFloat(h);
  const top = getFloat(y) - height;
  if (rotation === 90) {
    return {
      left: pageWidth - height - top,
      top: left,
      width: height,
      height: width,
    };
  }
  if (rotation === 180) {
    return {
      left: pageWidth - width - left,
      top: pageHeight - height - top,
      width,
      height,
    };
  }
  if (rotation === 270) {
    return {
      left: top,
      top: pageHeight - width - left,
      width: height,
      height: width,
    };
  }
  return {
    left,
    top,
    width,
    height,
  };
}

// eslint-disable-next-line max-len
export function getPreviewStyle(documentId, width, initialRotation, image) {
  const rotation = getRotateByDocID(documentId) ? getRotateByDocID(documentId)[0] : initialRotation;
  const ratio = image.naturalHeight / image.naturalWidth;

  const angleRotation = rotation === 90 || rotation === 270;

  return {
    width: `${angleRotation ? width / ratio : width}px`,
    height: `${angleRotation ? width : width * ratio}px`,
    opacity: 1,
    transformOrigin: '50% 50%',
    transform: typeof rotation === 'number' ? `rotate(${rotation}deg)` : null,
  };
}

export function createPageParams(documentRotate, rotationState) {
  return (idx) => {
    const lsRotate = _.get(rotationState, idx);
    const rotate = _.isNumber(lsRotate) ? lsRotate : documentRotate.get(idx, 0);
    return PageParamsFactory({ idx, rotate });
  };
}

export function findIndex(target) {
  return (a, v, i) => {
    if (v === target) return i;
    if (typeof a !== 'undefined') return a;
    return a;
  };
}

export function cancellation(fn) {
  let cancel = false;
  return {
    onCancel() {
      cancel = true;
    },
    execute(...args) {
      if (!cancel) fn(...args);
    },
  };
}
